import { render, staticRenderFns } from "./RewardsCardReceiver.vue?vue&type=template&id=f42844ce&scoped=true&"
import script from "./RewardsCardReceiver.vue?vue&type=script&lang=js&"
export * from "./RewardsCardReceiver.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardReceiver.vue?vue&type=style&index=0&id=f42844ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42844ce",
  null
  
)

export default component.exports